import { TFunction } from "@impero-com/common/utils/i18n";
import { Cascader } from "antd";

import {
    buildStatusCascaderOptions,
    cascaderValueToStatusTokens,
    statusTokensToCascaderValue,
} from "../utils/statusFilterOptions";

import * as theme from "./StatusCascader.css";

interface StatusCascaderProps {
    t: TFunction;
    placeholder?: string;
    value: string[] | null;
    setFilterValue: (value: string[] | null) => void;
}

/**
 * Status filter for the control activities list. Groups reviewer statuses so
 * an aggregate (parent) selection returns the union of the single-reviewer and
 * both detailed (1st/2nd) variants.
 */
export function StatusCascader({
    t,
    placeholder,
    value,
    setFilterValue,
}: StatusCascaderProps) {
    const options = buildStatusCascaderOptions(t);
    const cascaderValue = statusTokensToCascaderValue(value ?? []);

    // Collapse cascader paths back to tokens; empty selection clears the filter.
    const handleChange = (paths: (string | number)[][]) => {
        const tokens = cascaderValueToStatusTokens(
            paths.map((path) => path.map(String))
        );
        setFilterValue(tokens.length > 0 ? tokens : null);
    };

    return (
        <Cascader
            multiple
            showSearch
            autoFocus
            className={theme.cascader}
            placeholder={placeholder}
            options={options}
            value={cascaderValue}
            onChange={handleChange}
            // Show only the most specific label (leaf or aggregate), not the full path.
            displayRender={(labels) => labels[labels.length - 1]}
        />
    );
}
